var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4472_47634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00003 14.6666C8.73337 14.6666 9.33337 14.0666 9.33337 13.3333H6.6667C6.6667 14.0666 7.26003 14.6666 8.00003 14.6666ZM12 10.6666V7.33329C12 5.28663 10.9067 3.57329 9.00003 3.11996V2.66663C9.00003 2.11329 8.55337 1.66663 8.00003 1.66663C7.4467 1.66663 7.00003 2.11329 7.00003 2.66663V3.11996C5.0867 3.57329 4.00003 5.27996 4.00003 7.33329V10.6666L3.14003 11.5266C2.72003 11.9466 3.01337 12.6666 3.6067 12.6666H12.3867C12.98 12.6666 13.28 11.9466 12.86 11.5266L12 10.6666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4472_47634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.5322970d9f8bbaa115478c92d3df67d4.svg";
export { ForwardRef as ReactComponent };